import {trans} from "../translations/translations";

export const endPointELearning = {
    auth: '',
    app: ''
}

export const EndPointCustomerHub = {
    eLearning: "/elearning",
    login: "/customer/login",
    info: "/customer/info",
    me: '/customer/me',
    updateCustomer: '/customer/update',
    checkMail: "/customer/check-email",
    resetPassword: "/customer/reset-password",
    updatePassword: "/customer/update-password",
    updateLegal: "/customer/update-legal",
    log: "/log",
    grayLog: "/graylog",
    getCmd: "/command/customer",
    getCmd2: "command/customer",
    getOrders: "/orders",
    getRdv: "/rdv/customer",
    getSlots: "/rdv/available",
    reservationRdv: "/rdv/reservation",
    removeRdv: "/rdv/reservation/remove",
    confirmationRdv: "/rdv/confirmation",
    getMeasures: "/weight",
    sendEmail: "/email",
    stats: "/stats/italy",
    getPersonalisation: "/get-personalisation",
    sendPersonalisation: "/send-personalisation",
    getAdvices: "/advices",
    getTokenFromSecureVault: "customer/get-secure-token",
    sendNewDeliveryDate: "/orders/new-delivery-date",
    invoice: "/order/get-invoice"
}

export const PATH_IMAGE = "/images/meals"

export const genderConstant = {
    FEMALE: "female",
    MALE: "male"
}

export const LegalDocumentName = {
    cgu: "cgv.pdf",
    cgv: "cgv.pdf",
    rgpd: "cgv.pdf"
}

export const endpoints = {
    faq: "/questions-frequentes"
}

export const labelGraphs = {
    ALL: trans('pages.success.graph.all'),
    YEAR: trans('pages.success.graph.views.year'),
    MONTH: trans('pages.success.graph.views.month'),
    WEEK: trans('pages.success.graph.views.week')
}

export const passwordTypeRef = {
    user: 1,
    auto: 2
}

export const ORIGIN = "customerSpace";
export const TIMEOUT_DURATION = 3600;

export const refBrand = {
    equ: 11,
    cja: 1,
    mip: 6
}

export const refRules = {
    el: 1,
}

export const accessStatus = {
    el: true
}

export const ACTIVE = "active";
export const ATTENTE = "attente";
export const ENDED = "terminee";
export const TYPE_PERSONALISATION_CUSTOMIZABLE = 1;
export const TYPE_PERSONALISATION_NO_CUSTOMIZABLE = 0;
export const MULTI_ACTIVE_COMMAND = -1;
export const COMMAND_ENDED = -2;
export const STATUS_NULL = -3
export const NO_PERSONALISATION = -4;
